import AlertsRequester from './AlertsRequester';

export default AlertsRequester;
